import React from 'react';
import { components, ControlProps } from 'react-select';
import styled from 'styled-components';

import { Search } from '@lt/components/icons-react/userflow';
import { DepartureOption } from '@lt/api/dist/types/departure';

import { departurePickerName } from '../../constants';

export const Control = ({ children, ...props }: ControlProps<DepartureOption, false>) => (
  <components.Control {...props}>
    <SearchIcon className={`${departurePickerName}__icon-search`} />
    {children}
  </components.Control>
);

const SearchIcon = styled(Search)`
  width: 24px;
  height: 24px;
  stroke: #919499;
`;
